import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/wcht_dramatag",
    name: "wcht_dramatag",
    redirect: "/wcht_dramatag/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wcht_dramatag_index",
        meta: {title: "剧本标签", isIndex: true, keepAlive: true},
        component: () => import("@/pages/wcht/dramatag/index")
      }
    ]
  },

  {
    path: "/wcht_drama",
    name: "wcht_drama",
    redirect: "/wcht_drama/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wcht_drama_index",
        meta: {title: "剧本定义", isIndex: true, keepAlive: true},
        component: () => import("@/pages/wcht/drama/index")
      },
      {
        path: "edit",
        name: "wcht_drama_edit",
        meta: {title: "编辑剧本", isIndex: false, keepAlive: false},
        component: () => import("@/pages/wcht/drama/edit")
      },
      {
        path: "view",
        name: "wcht_drama_view",
        meta: {title: "查看剧本", isIndex: false, keepAlive: false},
        component: () => import("@/pages/wcht/drama/view")
      }
    ]
  },

  {
    path: "/wcht_wchtSop",
    name: "wcht_wchtSop",
    redirect: "/wcht_wchtSop/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wcht_wchtSop_index",
        meta: {title: "活动管理",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/wcht/sop/index")
      },
    ]
  },

  {
    path: "/wcht_activityAction",
    name: "wcht_activityAction",
    redirect: "/wcht_activityAction/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wcht_activityAction_index",
        meta: {title: "活动监听",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/wcht/activityAction/index")
      }
    ]
  },

  {
    path: "/wcht_dataCenter",
    name: "wcht_dataCenter",
    redirect: "/wcht_dataCenter/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wcht_dataCenter_index",
        meta: {title: "企微报表",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/wcht/dataCenter/index")
      }
    ]
  },

  {
    path: "/wcht_monitoringCenter",
    name: "wcht_monitoringCenter",
    redirect: "/wcht_monitoringCenter/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wcht_monitoringCenter_index",
        meta: {title: "监控中心",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/wcht/monitoringCenter/index")
      }
    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/wcht.js